<template>
  <s-form @submit="saveGathering">
    <fieldset class="m-form-fieldset m-form-fieldset--no-margin">
      <div class="h-grid h-grid--justify-content-center h-grid--row-gutter">
        <div class="h-grid__col h-grid__col--sm-10 h-grid__col--md-8">
          <h4>{{ $t('label-edit-gathering-signature-title') }}</h4>
          <ul>
            <li v-html="$t('label-edit-gathering-signature-bullet-point-1')"></li>
            <li v-html="$t('label-edit-gathering-signature-bullet-point-2')"></li>
            <li>{{ $t('label-edit-gathering-signature-bullet-point-3') }}</li>
            <li>{{ $t('label-edit-gathering-signature-bullet-point-4') }}</li>
            <li>{{ $t('label-edit-gathering-signature-bullet-point-5') }}</li>
          </ul>
          <p>{{ $t('label-edit-gathering-signature-bullet-paragraph-1') }}</p>
          <p>{{ $t('label-edit-gathering-signature-bullet-paragraph-2') }}</p>

          <span class="a-form-checkbox a-form-checkbox--block">
            <input type="checkbox" :value="false" id="organizerTermsOfUseAccepted" v-model="organizerTermsOfUseAccepted" autocomplete="edit-gathering organizer-terms-of-use-accepted" />
            <label for="organizerTermsOfUseAccepted">{{ $t('label-edit-gathering-organizer-terms-of-use-accepted') }}</label>
            <span v-if="$v.organizerTermsOfUseAccepted.$dirty">
              <span class="m-form-group__error" v-if="!$v.organizerTermsOfUseAccepted.isChecked">{{ $t('error-checkbox-required') }}</span>
            </span>
          </span>
        </div>

        <div class="h-grid__col h-grid__col-12">
          <div class="m-form-highlight m-form-highlight--secondary-color h-remove-child-margin">
            <label class="m-form-highlight__detail" for="signature" v-html="$t('label-edit-gathering-signature')" />

            <div class="m-form-highlight__cell">
              <div class="m-form-group">
                <input class="a-form-control a-form-control--huge" id="signature" v-model.trim="$v.signature.$model" autocomplete="edit-gathering signature" />
                <span v-if="$v.signature.$dirty">
                  <span class="m-form-group__error" v-if="!$v.signature.required">{{ $t('error-field-required') }}</span>
                </span>
              </div>
            </div>

            <span class="m-form-highlight__detail">{{ this.date }}</span>
          </div>
        </div>
      </div>
    </fieldset>

    <action-buttons
      :showSubmit="true"
      :isSubmitted="isSubmitted"
      :isAuthorized="isAuthorized"
      :errors="errors"
      @saveAndBack="saveAndBack"
      @saveAndQuit="saveAndQuit"
      @submitGathering="submitGathering"
      @previewGathering="previewGathering"
    />
  </s-form>
</template>

<script>
import SForm from '@/components/form/form'
import { required } from 'vuelidate/lib/validators'
import ActionButtons from '@/components/pages/gathering/edit-steps/action-buttons'

import GatheringService from '@/services/gathering'
import LoaderService from '@/services/loader'

const isChecked = value => value === true

export default {
  components: {
    SForm,
    ActionButtons
  },
  props: {
    value: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      signature: this.value.Signature ? this.value.Signature : '',
      isSubmitted: this.value.IsSubmitted !== null ? this.value.IsSubmitted : false,
      isAuthorized: this.value.IsPublish !== null ? this.value.IsPublish : false,
      organizerTermsOfUseAccepted: this.value.OrganizerTermsOfUseAccepted !== null ? this.value.OrganizerTermsOfUseAccepted : false
    }
  },
  validations: {
    signature: {
      required
    },
    organizerTermsOfUseAccepted: {
      isChecked
    }
  },
  computed: {
    gathering: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    date: function() {
      const today = new Date()
      return today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
    },
    errors: function() {
      const errors = []

      if (this.$v.$invalid) {
        if (!this.$v.organizerTermsOfUseAccepted.isChecked) {
          errors.push(this.$t('gathering-organizer-terms-not-accepted-error-text'))
        }

        if (!this.$v.signature.required) {
          errors.push(this.$t('gathering-signature-error-text'))
        }
      }

      return errors
    }
  },
  methods: {
    saveGathering: async function(submit = false) {
      if (this.signature !== '') {
        LoaderService.showLoader()

        const request = {
          gatheringId: this.gathering.Id
        }

        if (this.signature !== this.gathering.Signature) {
          request.signature = { value: this.signature }
        }

        if (this.date !== this.gathering.SignatureDate) {
          request.signatureDate = { value: this.date }
        }

        if (this.organizerTermsOfUseAccepted !== this.gathering.OrganizerTermsOfUseAccepted) {
          request.organizerTermsOfUseAccepted = { value: this.organizerTermsOfUseAccepted }
        }

        const response = await GatheringService.updateGathering(request)
        this.gathering = response

        if (submit) {
          this.gathering = await GatheringService.submitGathering(this.gathering.Id)
        }

        LoaderService.hideLoader()
      }
    },
    canSave: function(forceValidation = false) {
      if (this.isSubmitted || this.isAuthorized || forceValidation) {
        this.$v.$touch()
        return !this.$v.$invalid
      }
      return true
    },
    saveAndBack: async function() {
      if (this.canSave()) {
        await this.saveGathering()
        this.$emit('saveAndBack')
      }
    },
    previewGathering: async function() {
      if (this.canSave()) {
        await this.saveGathering()
        this.$emit('previewGathering')
      }
    },
    saveAndQuit: async function() {
      if (this.canSave()) {
        await this.saveGathering()
        this.$emit('saveAndQuit')
      }
    },
    submitGathering: async function() {
      if (this.canSave(true)) {
        await this.saveGathering(true)
        this.$emit('submitGathering')
      }
    }
  }
}
</script>
